let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Nsh8")).then(() => parcelRequire('8WAlV'));